import type { FC } from "react";
import { assert } from "@/helpers/console.ts";

interface FlowMessageTextProps {
  src: string;
}

/**
 *
 * @remarks Parent container should have a flex display so the right-sided messages can use flex-end
 */
export const FlowMessageVideo: FC<FlowMessageTextProps> = ({ src }) => {
  assert(src.length > 0, "Video src length needs to be more than 0");

  // oxlint-disable-next-line jsx-a11y/media-has-caption
  return <video style={{ contentVisibility: "visible" }} src={src} width={560} controls></video>;
};
